module.exports = __webpack_public_path__ + "static/nilson-1e9dfde49eeed8fd901d81e903755352.png";